
export const SCRIPT_KOC_CUSTORM_COLUMN_STORAGE_KEY =
  'script-koc:custorm-column';